import React from "react";
import { useSelector } from "react-redux";

//let navigationSections = ["home", "about", "works", "skills", "contact"]
let navigationSections;

const NavigationDots = ({ active }) => {
  const { content } = useSelector((state) => state.content);

  const { navbarLinks } = content.navbar;

  navigationSections = navbarLinks;

  return (
    <div className="app__navigation">
      {navigationSections.map((item, index) => (
        <a
          key={item + index}
          href={`#${item}`}
          className="app__navigation-dot"
          style={active === item ? { backgroundColor: "#313BAC" } : {}}
        />
      ))}
    </div>
  );
};

export default NavigationDots;
